const guideNumberCollator = new Intl.Collator('es', { numeric: true, sensitivity: 'base' });

export function resolveSortableGuideNumber(guide = {}) {
  return String(
    guide.nro_guia
      ?? guide.numero_guia
      ?? guide.numeroGuia
      ?? guide.numero
      ?? guide.id
      ?? '',
  ).trim();
}

export function sortGuidesByNumber(guides = []) {
  return [...guides].sort((left, right) => {
    const comparison = guideNumberCollator.compare(
      resolveSortableGuideNumber(left),
      resolveSortableGuideNumber(right),
    );
    if (comparison !== 0) return comparison;
    return guideNumberCollator.compare(String(left?.id ?? ''), String(right?.id ?? ''));
  });
}
